module.exports = __webpack_public_path__ + "img/section-hero.62374f3a.png";